import React from 'react';

const CGUPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-12">
        <h1 className="text-2xl font-bold text-gray-800 mb-8">
          Conditions Générales d'Utilisation de la plateforme ChatConsult
        </h1>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Introduction</h2>
          <p className="text-gray-600 mb-4">
            Les présentes conditions d'utilisation (ci-après les « CGU ») sont conclues entre :
          </p>
          <p className="text-gray-600 mb-4">
            La société SapiensIA SAS, au capital social de 10 000 euros, immatriculée au Registre du Commerce et des Sociétés de Toulouse sous le numéro 993 058 544, dont le siège est situé 13 Port Saint Etienne, 31000 Toulouse<br />
            <br />(ci-après désigné « le Fournisseur »)
          </p>
          <p className="text-gray-600 mb-4">
            Et :
          </p>
          <p className="text-gray-600 mb-4">
            Toute personne physique ou morale, agissant en qualité de professionnel, qui accède et utilise la solution ChatConsult proposée par le Fournisseur en mode Software as a Service (SaaS) via le site internet https://chatconsult.fr/ ou tout autre moyen fourni par le Fournisseur,<br />
            <br />(ci-après désigné « l'Utilisateur »)
          </p>
          <p className="text-gray-600 mb-4">
            Les présentes CGU ont pour objet de définir les termes et conditions selon lesquels le Fournisseur met à disposition des Utilisateurs la Solution ChatConsult (ci-après la « Solution ») ainsi que l'utilisation des services associés. Les CGU sont indissociables des Conditions Générales de Vente (ci-après les « CGV ») et toute référence aux CGV implique la prise en compte des CGU et vice-versa. L'utilisation de la Solution vaut acceptation intégrale et sans réserve des présentes CGU et des CGV par l'Utilisateur.
          </p>
          <p className="text-gray-600 mb-4">
            Les CGU sont accessibles à tout moment sur le site web du Fournisseur https://chatconsult.fr/cgu et prévalent sur tout autre document émanant du Fournisseur, sauf accord dérogatoire exprès et préalable du Fournisseur.
          </p>
          <p className="text-gray-600">
            Le Fournisseur se réserve le droit de modifier les CGU à tout moment, sous réserve d'en informer l'Utilisateur par tout moyen approprié (courrier électronique, affichage sur la plateforme, etc). L'Utilisateur aura alors la possibilité de refuser cette modification durant une période de quinze (15) jours à compter la notification de cette modification. Le cas échéant, l'Utilisateur notifiera son refus durant ce délai par courrier électronique (à l'adresse : contact@sapiensia.fr) ou par lettre recommandée avec accusé de réception adressée au siège social du Fournisseur. Dès la réception de ce refus, le Fournisseur aura le choix : (i) soit ne pas appliquer la modification à l'Utilisateur ; (ii) soit résilier les présentes CGU en respectant un délai minimum d'un (1) mois.
          </p>
          <p className="text-gray-600 mt-4">
            À défaut, l'Utilisateur sera réputé avoir accepté les modifications. En tout état de cause, toute modification sera applicable à l'Utilisateur lors du renouvellement ou de la reconduction du Contrat ou pour tout nouvel Abonnement et ce, même sans notification préalable.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Définitions</h2>
          <ul className="space-y-2 text-gray-600">
            <li><span className="font-medium">Solution :</span> La plateforme ChatConsult d'assistants IA</li>
            <li><span className="font-medium">Utilisateur :</span> Toute personne physique disposant d'un accès nominatif à la Solution.</li>
            <li><span className="font-medium">Fournisseur :</span> L'entité responsable de la gestion et de la maintenance de la Solution.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 1 - Accès et utilisation de l'application</h2>
          <p className="text-gray-600">
            L'Utilisateur s'engage à utiliser la Solution de manière conforme aux présentes CGU, aux CGV et aux lois et règlementations en vigueur. Toute tentative d'accès non autorisé, de modification ou d'utilisation abusive de la Solution est strictement interdite.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 2 - Compte utilisateur</h2>
          <h3 className="text-sm font-medium text-gray-600 italic mb-2">2.1 Création et gestion du compte utilisateur</h3>
          <p className="text-gray-600 mb-4">
            Pour accéder aux fonctionnalités de la Solution, l'Utilisateur doit créer un compte ou demander la création d'un compte au Fournisseur. L'Utilisateur s'engage à fournir des informations exactes et à jour.
          </p>
          <h3 className="text-sm font-medium text-gray-600 italic mb-2">2.2 Confidentialité</h3>
          <p className="text-gray-600 mb-4">
            L'Utilisateur est responsable de la sécurité de ses identifiants. Il s'engage à préserver la confidentialité de ses identifiants, à ne pas partager ses identifiants à toute autre personne non autorisée, et à assumer la responsabilité de toute activité réalisée sous son compte sur la Solution. Ainsi toute activité réalisée via son compte sera considérée comme effectuée par lui.
          </p>
          <h3 className="text-sm font-medium text-gray-600 italic mb-2">2.3 Suspension ou suppression</h3>
          <p className="text-gray-600">
            Le Fournisseur se réserve le droit de suspendre ou supprimer tout compte en cas de violation des CGU ou des CGV.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 3 - Propriété intellectuelle</h2>
          <p className="text-gray-600">
            À l'exception des contenus apportés par l'Utilisateur et de ceux générés par les conversations, tous les contenus, marques, logos et autres éléments présents sur la Solution sont protégés par des droits de propriété intellectuelle. L'utilisateur ne peut copier, modifier ou distribuer ces contenus sans autorisation expresse du Fournisseur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 4 – Reproduction interdite</h2>
          <p className="text-gray-600 mb-4">
            L'Utilisateur reconnaît que l'ensemble des éléments composant la Solution, incluant notamment, sans que cette liste soit limitative, les fonctionnalités, l'architecture, les interfaces (UX/UI), les contenus, les textes, les bases de données, les cas d'usage, les paramétrages, les logiques de fonctionnement ainsi que les éléments liés aux assistants IA, sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive du Fournisseur.
          </p>
          <p className="text-gray-600 mb-3">En conséquence, l'Utilisateur s'interdit, directement ou indirectement, de :</p>
          <ul className="list-disc list-inside space-y-1 text-gray-600 ml-4">
            <li>reproduire, copier, modifier, assembler, décompiler ou désassembler tout ou partie de la Solution ;</li>
            <li>reproduire ou réutiliser les interfaces, parcours utilisateurs ou structures fonctionnelles ;</li>
            <li>extraire ou réutiliser de manière substantielle tout contenu ou élément de la Solution ;</li>
            <li>reproduire les cas d'usage, méthodologies ou organisations présentés.</li>
          </ul>
          <p className="text-gray-600 mt-4">
            Toute reproduction, totale ou partielle, sans autorisation écrite préalable du Fournisseur, est strictement interdite et susceptible d'engager la responsabilité de l'Utilisateur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 5 – Usage limité et interdiction d'exploitation lors d'une phase de test</h2>
          <p className="text-gray-600 mb-4">
            Le Fournisseur peut accorder à L'Utilisateur un droit d'accès à la Solution strictement limité à un usage d'évaluation, de test ou de démonstration, à l'exclusion de tout usage commercial ou opérationnel.
          </p>
          <p className="text-gray-600 mb-3">Dans ce cadre, l'Utilisateur s'interdit expressément, directement ou indirectement, de :</p>
          <ul className="list-disc list-inside space-y-1 text-gray-600 ml-4">
            <li>exploiter les informations, concepts, fonctionnalités ou cas d'usage issus de la Solution à des fins commerciales ;</li>
            <li>développer, faire développer ou promouvoir une solution concurrente fondée, en tout ou partie, sur les éléments observés ou expérimentés sur la Solution ;</li>
            <li>réutiliser les idées, structures, organisations fonctionnelles ou logiques métiers présentées dans le cadre de la Solution pour concevoir une offre similaire ;</li>
            <li>tirer un avantage économique ou stratégique des informations obtenues lors de l'utilisation de la Solution.</li>
          </ul>
          <p className="text-gray-600 mt-4">
            L'Utilisateur reconnaît que toute utilisation non conforme constituerait un acte de concurrence déloyale et/ou de parasitisme économique, susceptible d'engager sa responsabilité.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 6 – Données personnelles et sécurité</h2>
          <h3 className="text-sm font-medium text-gray-600 italic mb-2">6.1 Données personnelles</h3>
          <p className="text-gray-600 mb-4">
            Le traitement des données personnelles effectué dans le cadre de l'utilisation de la Solution est soumis aux règlementations en vigueur (RGPD en particulier), ainsi qu'à la politique de confidentialité du Fournisseur.
          </p>
          <h3 className="text-sm font-medium text-gray-600 italic mb-2">6.2 Sécurité</h3>
          <p className="text-gray-600">
            Le Fournisseur s'engage à prendre les mesures nécessaires pour assurer la sécurité et la confidentialité des données de l'Utilisateur.<br />
            L'Utilisateur est responsable de la protection de son propre environnement informatique.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 7 - Limitation de responsabilité</h2>
          <p className="text-gray-600">
            La Solution est fournie "en l'état". Le Fournisseur ne garantit pas l'absence d'erreurs ou d'interruptions. Le Fournisseur ne saurait être tenus responsable des dommages indirects, pertes de données ou autres préjudices résultant de l'utilisation ou de l'impossibilité d'utiliser la Solution.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 8 – Durée</h2>
          <p className="text-gray-600">
            Les CGU prennent effet dès la première utilisation de la Solution par l'Utilisateur et restent en vigueur pendant toute la durée d'utilisation de la Solution par l'Utilisateur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 9 - Modification des CGU</h2>
          <p className="text-gray-600">
            Les présentes CGU peuvent être mises à jour à tout moment. En cas de modification substantielle, une notification sera envoyée via la Solution ou par mail. Il vous appartient de consulter régulièrement les CGU pour rester informé.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 10 - Résiliation</h2>
          <p className="text-gray-600">
            L'Utilisateur peut cesser d'utiliser la Solution à tout moment. Le Fournisseur se réserve le droit de suspendre ou résilier l'accès à la Solution en cas de non-respect des CGU ou pour des raisons techniques ou légales.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Article 11 - Droit applicable et litiges</h2>
          <p className="text-gray-600 mb-4">
            Les présentes CGU sont régies par les lois françaises en vigueur. En cas de litige, les parties s'engagent à rechercher une solution amiable avant toute procédure judiciaire.
          </p>
          <p className="text-gray-600">
            A défaut de règlement amiable dans un délai de 30 jours à compter de la notification du litige par l'une ou l'autre des parties, le litige sera soumis à la compétence exclusive du tribunal de commerce de Toulouse, nonobstant pluralité de défendeurs ou appel en garantie.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="text-lg font-semibold text-gray-700 mb-3">Contact</h2>
          <p className="text-gray-600">
            Pour toute question ou réclamation concernant ces CGU, veuillez nous contacter via la page Contact.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CGUPage;
